import { HCF, HUtils } from "@macashipo/mlib"
import { useEffect, useState } from "react"
import { BiInfoCircle } from "react-icons/bi"
import { MdArrowBackIos } from "react-icons/md"
import { Button, Input } from "reactstrap"
import { MyForm, MyUI } from "src/core/components"
import { useForceUpdate } from "src/modules/app_sigo/hooks/useForceUpdate"
import styled from "styled-components"

const MyUIUserRegister = props => {
  const { isActive, fnList } = props
  // const [showPwd, setShowPwd] = useState(false)
  // const [showConfirmPwd, setShowConfirmPwd] = useState(false)
  const [loading, setLoading] = useState(false)
  const [msg, setMsg] = useState("")
  const [data, setData] = useState({} as any)
  const dfMsgInfo = HUtils.get(HCF.getCF("websiteSetting"), "auth") || {}

  const [keyUIInput, forceUpdateKeyInput] = useForceUpdate()
  const configFieldData = {
    pwd: "Password",
    confirmPwd: "ConfirmPassword",
    displayName: "DisplayName",
    firstName: "FirstName",
    lastName: "LastName",
  }
  // Reset msg, display name và password mỗi khi active tab user_register
  useEffect(() => {
    if (isActive) {
      setMsg("")
      setData({})
      forceUpdateKeyInput()
    }
  }, [isActive])
  const getConfigMsgCreateAccount = () => {
    return dfMsgInfo?.config_msg_create_account
  }
  const getConfigFormRegister = () => {
    const dfMsg = getConfigMsgCreateAccount() || {}
    return {
      defaultValues: data,
      controls: [
        {
          type: "input_text",
          fieldName: configFieldData.firstName,
          more: {
            placeholder: "Tên",
            needRemoveExtraSpace: true,
            needUpdateImmediate: true,
            classNameGroup: "cus-style firstname",
            specialFormat: onFormatName,
            onHandleKeyDown: onHandleKeyDown,
            autoFocus: true,
            disabled: loading,
          },
        },
        {
          type: "input_text",
          fieldName: configFieldData.lastName,
          more: {
            placeholder: "Họ",
            needUpdateImmediate: true,
            needRemoveExtraSpace: true,
            classNameGroup: "cus-style lastname",
            specialFormat: onFormatName,
            onHandleKeyDown: onHandleKeyDown,
            disabled: loading,
          },
        },
        ...(dfMsg?.msg_after_name
          ? [
              {
                type: "only_label",
                fieldName: "fEmptyField1",
                label: (
                  <div className="form-description">
                    {dfMsg?.msg_after_name}
                  </div>
                ),
                more: {
                  classNameGroup: "form-description",
                },
              },
            ]
          : []),
        {
          label: "",
          type: "input_password_v2",
          fieldName: configFieldData.pwd,
          more: {
            classNameGroup: "password",
            placeholder: "Tạo mật khẩu của bạn",
            needUpdateImmediate: true,
            onHandleKeyDown: onHandleKeyDown,
            disabled: loading,
          },
        },
        ...(dfMsg?.msg_after_pwd
          ? [
              {
                type: "only_label",
                fieldName: "fEmptyField1",
                label: (
                  <div className="form-description">{dfMsg?.msg_after_pwd}</div>
                ),
              },
            ]
          : []),
        ...(dfMsg?.msg_confirm
          ? [
              {
                type: "only_label",
                fieldName: "fEmptyField1",
                label: (
                  <div
                    className="form-confirm"
                    dangerouslySetInnerHTML={{ __html: dfMsg?.msg_confirm }}
                  ></div>
                ),
              },
            ]
          : []),
      ],
    }
  }
  const getDisabledCreateAccountBtn = () => {
    if (
      !data ||
      // !data?.[configFieldData.confirmPwd] ||
      !data?.[configFieldData.firstName] ||
      !data?.[configFieldData.lastName] ||
      !data?.[configFieldData.pwd] ||
      loading
    ) {
      return true
    }
    return false
  }
  const onHandleKeyDown = e => {
    if (!getDisabledCreateAccountBtn()) {
      fnList?.handlePressEnter && fnList?.handlePressEnter(e, onCreateAccount)
    }
  }
  const onFormatName = value => {
    let newValue = value
    if (value && typeof value === "string") {
      const words = value?.split(" ")
      newValue = words
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    }
    return newValue
  }
  const onChangeData = (value, field) => {
    setMsg("")
    let newData = {
      ...data,
      [field]: value,
    }
    setData(newData)
  }
  const onCreateAccount = () => {
    if (fnList && fnList?.onCreateAccount) {
      setLoading(true)
      fnList?.onCreateAccount(data, {
        cbSuccess: () => {
          setLoading(false)
        },
        cbError: msg => {
          setLoading(false)
          if (msg) {
            setMsg(msg)
          }
        },
      })
    }
  }

  return (
    <MyUI
      type="sg_loading_overlay"
      // isLoading={loading}
      showLoadingIcon={false}
    >
      <Wrap
        className="mui-user-register tabdk"
        style={{ display: isActive ? "block" : "none" }}
      >
        <div className="header">
          {/* <Button
          color="hide-modal"
          onClick={() => {
            fnList?.onGoBack && fnList?.onGoBack()
          }}
        >
          <MdArrowBackIos />
        </Button> */}
          <div className="title only-title">Hoàn tất đăng ký</div>
        </div>
        <div className="body">
          <MyForm
            key={keyUIInput}
            configForm={getConfigFormRegister() as any}
            fnList={
              {
                afterUpdateValueControl: (opts: any) => {
                  const { fieldName, newValue } = opts
                  onChangeData(newValue, fieldName)
                },
              } as any
            }
            renderFooter={() => {
              return <></>
            }}
          />
        </div>
        {msg && (
          <Error className="__msgerr">
            <BiInfoCircle />
            <div>{msg}</div>
          </Error>
        )}
        {/* <div
        id="messlogin"
        className="showmessage"
        style={msg ? { display: "block" } : { display: "none" }}
      >
        {msg}
      </div> */}
        <MyUI
          type="sg_button"
          onClick={onCreateAccount}
          color="primary-v2"
          className="btn-lg btn-block btnlogin"
          disabled={getDisabledCreateAccountBtn()}
          loading={loading}
          btnName="Đồng ý & Tiếp tục"
          loadingColor={"#fff"}
        />
      </Wrap>
    </MyUI>
  )
}
const Error = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--color-danger);
  font-size: 14px;
  margin: 5px 0;
  & > svg {
    margin-right: 0.25rem;
    width: 15px;
    height: 15px;
  }
`
const Wrap = styled.div`
  & .my-form {
    & .cus-style {
      margin-bottom: 0px !important;
      & .form-control {
        text-transform: capitalize;
      }
    }
    & .form-control {
      min-height: 46px;
      border-radius: 8px !important;
    }
    & .form-control:focus,
    & .form-control:hover {
      border-color: #ccc;
    }
    & .firstname {
      & .form-control {
        border-radius: 8px 8px 0 0 !important;
        border-bottom: none;
      }
    }
    & .lastname {
      & .form-control {
        border-radius: 0 0 8px 8px !important;
        margin-bottom: 15px !important;
      }
    }
    & .form-description {
      margin-bottom: 25px;
      font-size: 13px;
      font-weight: 300;
      font-family: "Lexend", sans-serif;
      color: var(--color-text-000);
    }
    & .form-description:last-child {
    }
    & .inputpwd-v2 {
      & .hienpass {
        bottom: 11px;
        color: var(--color-ic-show-pwd);
      }
      & .hienpass:hover {
        color: var(--color-text-000);
      }
    }
    & .form-confirm {
      color: var(--color-text-000);
      a {
        color: var(--color-text-000);
        text-decoration: underline;
        font-weight: 700;
      }
      a:hover {
        color: var(--mau2);
      }
    }
  }
`
export default MyUIUserRegister
